import OpenIcon from "../images/OpenIcon.mjs";

/**
 * App icon for file/folder upload action
 * @see {GlyphIcon}
 * @see {OpenIcon}
 */
const AppUploadIcon = class extends OpenIcon {}

export default AppUploadIcon;
